module.exports = __webpack_public_path__ + "static/screenshot-6e26be0ea16966259b09d4c22d20e679.png";